export type CompanyListSearchItem = {
    id: number;
    name: string;
};

/** Exact company id first, then the remaining matches in name order. */
export function sortCompaniesWithExactIdFirst<T extends CompanyListSearchItem>(
    companies: T[],
    filterValue: string,
): T[] {
    const query = filterValue.trim();

    return [...companies].sort((left, right) => {
        const leftIsExactId = query !== "" && String(left.id) === query;
        const rightIsExactId = query !== "" && String(right.id) === query;
        if (leftIsExactId !== rightIsExactId) return leftIsExactId ? -1 : 1;
        return left.name.localeCompare(right.name);
    });
}
